import React, { forwardRef, PropsWithChildren } from "react";
import "./bottom-menu-panel.css";

/** Component for wrap bottom menu panels with, to make the panels the same style */
export const BottomMenuPanel = forwardRef<
	HTMLDivElement,
	PropsWithChildren<{ className?: string }>
>(({ className, children }, ref) => (
	<div className={`bottom-menu-panel ${className || ""}`} ref={ref}>
		{children}
	</div>
));
BottomMenuPanel.displayName = "BottomMenuPanel";
